import styled from 'styled-components';
import { darken, lighten } from 'polished';
import { ClockIcon } from '../uielements/icon/clock';
import { useSelector } from '@/redux';
import { getFontStyles } from '@/redux/cmsConfig/utils';
import { getReadableRange } from '@/utils/conveyance';
import { getLeadTimes } from '@/utils/locations';
import { selectConveyance } from '@/redux/conveyanceMode/reducer';
import { isDark } from '@/utils/global';

export const EstimatedPrepTime = () => {
  const { type } = useSelector(selectConveyance);
  const basketLocation = useSelector((state) => state.app.basket.location);
  const prepMinutes = getLeadTimes(basketLocation, type);

  return (
    <PrepTimeBlock data-testid="estimated-prep-time">
      <StyledClockIcon />
      <PrepTimeText>
        <PrepTimePrimary>Estimated Prep time {getReadableRange(prepMinutes)}</PrepTimePrimary>
        <PrepTimeClarifier>Final time confirmed at checkout</PrepTimeClarifier>
      </PrepTimeText>
    </PrepTimeBlock>
  );
};

const PrepTimeBlock = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => {
    const isDarkBg = theme.checkout.background_color && isDark(theme.checkout.background_color);
    return isDarkBg
      ? darken(0.58, theme.buttons.primary_button_background_color)
      : lighten(0.58, theme.buttons.primary_button_background_color);
  }};
  border-radius: 8px;
  padding: 6px 8px;
  border: 1px solid ${({ theme }) => theme.buttons.primary_button_border_color};
  gap: 8px;
`;

export const StyledClockIcon = styled(ClockIcon)(({ theme }) => ({
  display: 'flex',
  color: theme.buttons.primary_button_border_color,
  width: '26px',
  height: '26px',
}));

const PrepTimeText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const PrepTimePrimary = styled.span`
  color: ${({ theme }) => getFontStyles(theme.checkout.secondary_font).color};
  font-weight: 700;
  font-size: 13px;
  line-height: 14px;
`;

const PrepTimeClarifier = styled.span`
  color: ${({ theme }) => getFontStyles(theme.checkout.secondary_font).color};
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
`;
